import { render, staticRenderFns } from "./SCADA.vue?vue&type=template&id=90b3a70e&scoped=true&"
import script from "./SCADA.vue?vue&type=script&lang=js&"
export * from "./SCADA.vue?vue&type=script&lang=js&"
import style0 from "./SCADA.vue?vue&type=style&index=0&id=90b3a70e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90b3a70e",
  null
  
)

export default component.exports